var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReleaseIncidents(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0586 0L18.457 21.8419L23.951 20.2403V9.0649H27.8433L20.0586 0Z",
    fill: "#CC295F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2734 9.0649H16.1658V20.2403L20.0581 21.8419V0L12.2734 9.0649Z",
    fill: "#FF3377"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9879 21.8418L20.0586 20.2402L18.457 30.6198L20.0586 40.9994H34.9879V21.8418Z",
    fill: "#FFCC66"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.12891 21.8418V40.9994H20.0583V20.2402L5.12891 21.8418Z",
    fill: "#FFE666"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.88086 7.83008L3.80096 5.61031L8.24056 7.45054L7.32046 9.6703L2.88086 7.83008Z",
    fill: "#2EE6A8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41113 1.69922L8.10959 0.000761644L11.5065 3.39768L9.80805 5.09613L6.41113 1.69922Z",
    fill: "#2EE6A8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.96094 12.4434H6.76562V14.8457H1.96094V12.4434Z",
    fill: "#2EE6A8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8857 7.43945L36.3253 5.59926L37.2454 7.81902L32.8058 9.65922L31.8857 7.43945Z",
    fill: "#24B3B3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6055 3.40039L32.0023 0.00353373L33.7008 1.70199L30.3039 5.09885L28.6055 3.40039Z",
    fill: "#24B3B3"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3516 12.4453H38.1562V14.8477H33.3516V12.4453Z",
    fill: "#24B3B3"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M5.12926 20.2402L0 30.6198H15.0418L20.0586 20.2402H5.12926Z",
    fill: "#FFF2B3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9879 20.2402L40.1172 30.6198H25.0754L20.0586 20.2402H34.9879Z",
    fill: "#FFE666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReleaseIncidents);
export default __webpack_public_path__ + "static/media/ReleaseIncidents.3e06fd5a146822aa9bcf0fae94403af6.svg";
export { ForwardRef as ReactComponent };